<template>
	<div class="teikiArea"
		v-if="(ptInitData.teikiKounyuuOption == 1 && ptInitData.productInfo.TEIKI_KOUNYUU_KANOU_FLG == 1)">
		<dl class="teikiPriceInfo sort-item"
			v-if="!(ptInitData.siteKbn == '4' && !ptInitData.loginKbn && ptInitData.priceShowBtoB == 0) && ptInitData.priceShow != 1">
			<dt v-if="ptInitData.productInfo.POINT_ITEM_KBN == '0' || ptInitData.productInfo.POINT_ITEM_KBN == '2'">
				<label>
					<!-- <input type="radio" id="teikiKounyuu" class="teikiRadio" name="teikiKounyuu" value="1"
						v-model="teikiKounyuu"> -->
					{{ $t('pt125.labels.teikiLabel') }}{{ $t('common.labels.price') }}
				</label>
			</dt>
			<template
				v-if="ptInitData.productInfo.POINT_ITEM_KBN == '0' || ptInitData.productInfo.POINT_ITEM_KBN == '2'">
				<!-- 定期価格（税込） -->
				<dd v-if="ptInitData.productInfo.TAX_KBN == 1">
					<span class="teikiPrice">{{ formatPrice(ptInitData.productInfo.TEIKI_ZEI_K_TNK) }}{{
						$t('common.labels.jpYen') }}</span>
					&nbsp;<template v-if="ptInitData.productInfo.ITEM_ZEI_SET_KBN != '0'"><span class="teikiPriceZei">{{
						$t('common.labels.taxIncludeSale[1]') }}</span></template>
				</dd>
				<!-- 定期価格（税抜） -->
				<dd v-else>
					<span class="teikiPrice">{{ formatPrice(ptInitData.productInfo.TEIKI_TNK) }}{{
						$t('common.labels.jpYen')
					}}</span>
					&nbsp;<template v-if="ptInitData.productInfo.ITEM_ZEI_SET_KBN != '0'"><span class="teikiPriceZei">{{
						$t('common.labels.taxIncludeSale[2]') }}</span></template>
				</dd>
			</template>
		</dl>
	</div>
</template>
<script>

import cartContainer from './cartContainer.vue'
import common from "assets/js/common";
export default {
	components: {
		cartContainer
	},
	methods: {
		/**
	 * format number value to currency value
	 * @param {number} value, number to format
	 */
		formatPrice: function (value) {
			return common.formatPrice(value);
		},
		pt125doOrder: function (e) {
			this.$emit('pt125doOrder', e);
		}
	},
	name: 'TeikiPriceInfo',
	props: {
		ptInitData: {
			type: Object,
			default: null
		},
		doChkCartAddTxt: {
			type: Boolean
		},
		isLp: {
			type: Boolean,
			default: false
		},
		teikiKounyuu: {
			type: Number,
			default: 0
		}
	}
}
</script>